@use "@design/components/custom-scroll/custom-scroll" as *;
@use "@design/design-tokens/typography/typography" as *;

.root {
  position: relative;
  overflow: auto;
  @include custom-scroll-minimal;
  flex: 1 1 0;

  table tr:nth-last-child(-n + 2) td {
    border-bottom: none;
  }

  table tr:last-child td {
    cursor: default;

    &:hover {
      background-color: var(--background-default);
    }
  }
}

.rankWrapper {
  display: flex;
  flex-direction: row;
  gap: 4px;
  align-items: center;
}

.descriptionWrapper {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  font-family: var(--font-nort);
  @include typography-v2-body-sm;
}

.sectorName {
  font-family: var(--font-nort);
}

.sectorNa {
  @include typography-v2-ui-xs;
  color: var(--text-disabled);
  font-family: var(--font-nort);
}

.footerRow {
  padding: 20px 0 0;
}
